var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTcc(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 230 230",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#Degradado_sin_nombre_150);}.cls-2{fill:#fbda28;}.cls-3{fill:#dc1f27;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_150",
    x1: 115,
    y1: 275.29,
    x2: 115,
    y2: -103.82,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c21a21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#303133"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 230,
    height: 230
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-2",
    cx: 115,
    cy: 115,
    rx: 78.78,
    ry: 44.11
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115,161c-21.36,0-41.47-4.67-56.63-13.16-15.5-8.68-24-20.34-24-32.83s8.54-24.15,24-32.83C73.53,73.68,93.64,69,115,69s41.47,4.67,56.63,13.16c15.5,8.68,24,20.34,24,32.83s-8.54,24.15-24,32.83C156.47,156.32,136.36,161,115,161Zm0-88.22c-42.4,0-76.9,18.94-76.9,42.23s34.5,42.23,76.9,42.23,76.9-18.94,76.9-42.23S157.4,72.77,115,72.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M157.92,84.43c11.11,0,16,4.54,16,12.52-1,8.22-1.35,9.45-1.35,9.45h-15a54.32,54.32,0,0,0,1.35-6.63c.86-5.15-5.28-6.26-6.5-.77s-5.65,25.19-5.65,25.19-2.45,7.12,1.53,7.31,4.79-3.93,5.9-7.8,1-4.91,1-4.91h14.66s-1.9,15.41-9.45,20.56-10.74,4.11-15.22,4.11-13-2.51-14.11-7.85,1.5-14.7,3.28-23S137.49,84.43,157.92,84.43Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "94.69 99 59.81 99 62.43 85.98 97.32 85.98 94.69 99"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "69.73 98.53 60.97 141.99 75.8 141.99 84.55 98.53 69.73 98.53"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M118.49,84.43c11.11,0,16,4.54,16,12.52-1,8.22-1.35,9.45-1.35,9.45h-15a54.32,54.32,0,0,0,1.35-6.63c.86-5.15-5.28-6.26-6.51-.77s-5.64,25.19-5.64,25.19-2.46,7.12,1.53,7.31,4.79-3.93,5.89-7.8,1-4.91,1-4.91h14.66s-1.9,15.41-9.45,20.56-10.74,4.11-15.22,4.11-13-2.51-14.11-7.85,1.5-14.7,3.28-23S98.05,84.43,118.49,84.43Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTcc);
export default __webpack_public_path__ + "static/media/tcc.99b579f227e1c3af47cdfa599a051c0c.svg";
export { ForwardRef as ReactComponent };